import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { setFilters } from '@/store/slices/speakersSlice'
import Loader from '@/components/common/Loader'
import FaqAndInfo from '@/components/dashboard/FaqAndInfo'
import ExploreSpeakers from '@/components/dashboard/ExploreSpeakers'
import PopularTopics from '@/components/dashboard/PopularTopics'
import GetinContactSections from '@/components/dashboard/GetinContactSections'
import { Suspense, lazy } from 'react'
import { request } from '@/utils/axiosUtil'
import { setTypes } from '@/store/slices/speakerTypesSlice'
import { setCategory } from '@/store/slices/categorySlice'
import HomeBannerCarousel from '@/components/common/HomeBannerCarousel'

const Home = ({ data, trendingSpeakers, featuredSpeakers, categories, speakerTypes }) => {
  const router = useRouter()
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (categories) {
      dispatch(setCategory(categories))
    }
    if (speakerTypes) {
      dispatch(setTypes(speakerTypes))
    }
    setIsLoading(false)
  }, [categories, speakerTypes])

  const handleSpeakersRedirect = () => {
    dispatch(
      setFilters({
        categories: null,
        searchQuery: '',
        types: null,
        profileCategory: null,
        relatedSpeakers: null,
        sortOrder: null,
      })
    )
    router.push('/speakers')
  }

  if (router.isFallback) {
    return (
      <>
        <Loader />
      </>
    )
  }

  return (
    <>
      <div className="flex flex-col px-0">
        <main>
          <Suspense fallback={<Loader />}>
            <HomeBannerCarousel
              data={data?.curatedSpeakers}
              autoPlaySpeed={data.banner.homeBannerCarouselAutoPlaySpeedDuration}
            />
          </Suspense>
          <div className="uta-container">
            <div className="bannerButton minXs:mt-[73px] gap-3 flex">
              <a
                className="whitespace-nowrap text-center tagline-font bg-black minXs:px-10 border py-3 text-xs font-extrabold cursor-pointer minXs:w-[240px] w-[360px] maxSm:m-auto px-4 button-hover"
                onClick={() => handleSpeakersRedirect()}
              >
                View All UTA Speakers
              </a>
            </div>
          </div>
          <div className="browse-speakers-container">
            <ExploreSpeakers
              featuredSpeakers={featuredSpeakers}
              trendingSpeakers={trendingSpeakers}
              handleClick={() => handleSpeakersRedirect()}
            />
          </div>

          <div className="uta-container">
            <GetinContactSections data={data} isLoading={isLoading} />
            <PopularTopics data={data?.popularTopics} />
          </div>

          <FaqAndInfo />
        </main>
      </div>
    </>
  )
}
export async function getServerSideProps() {
  const apiUrl = '/home'
  const res = await request({ url: apiUrl })

  const trendingSpeakersUrl = '/trendingSpeakers'
  const trendingSpeakers = await request({ url: trendingSpeakersUrl })

  const featuredSpeakersUrl = '/featuredSpeakers'
  const featuredSpeakers = await request({ url: featuredSpeakersUrl })

  const categoriesUrl = '/categories'
  let categories = await request({ url: categoriesUrl })
  categories = categories?.data?.data
  categories.sort((a, b) => a.subCategories?.length - b.subCategories?.length)
  categories = [
    categories.find((category) => category.category === 'Popular & Trending'),
    ...categories.filter((category) => category.category !== 'Popular & Trending'),
  ]

  const speakerTypesUrl = '/speakerTypes'
  const speakerTypes = await request({ url: speakerTypesUrl })

  return {
    props: {
      data: res.data?.data,
      trendingSpeakers: trendingSpeakers.data?.data,
      featuredSpeakers: featuredSpeakers.data?.data,
      categories: categories,
      speakerTypes: speakerTypes.data?.data,
    },
  }
}
export default Home
